import { render, staticRenderFns } from "./Alliance.vue?vue&type=template&id=8b66d78c&scoped=true&"
import script from "./Alliance.vue?vue&type=script&lang=js&"
export * from "./Alliance.vue?vue&type=script&lang=js&"
import style0 from "./Alliance.vue?vue&type=style&index=0&id=8b66d78c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b66d78c",
  null
  
)

export default component.exports